<template>
  <div class="openApi box_1200">
    <el-tabs tab-position="left" class="api">
      <el-tab-pane label="实验结束第三方回传数据接口">
        <div class="item flex jc-between ai-center">
          <div class="label">接口地址: </div>
          <div class="cont flex-1">https://ai.cyzntech.com/studyPc/study/avoid/studyEnd</div>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">请求方式: </div>
          <div class="cont flex-1">POST</div>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">入参示例: </div>
          <pre class="cont flex-1">
            {
              "imageBase64": "string",
              "study_id": "string",
              "user_id": "string"
            }
          </pre>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">入参字段说明: </div>
          <pre class="cont flex-1">
            study_id: 实验id
            user_id: 用户id
            imageBase64: 图片base64
          </pre>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">出参格式: </div>
          <div class="cont flex-1">JSON</div>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">出参示例: </div>
          <pre class="cont flex-1">
            {
              "msg": "请求成功",
              "code": 200,
            }
          </pre>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">出参字段说明: </div>
          <div class="cont flex-1">code:200为成功 500异常</div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="实验新增接口">
        <div class="item flex jc-between ai-center">
          <div class="label">接口地址: </div>
          <div class="cont flex-1">https://aiht.cyzntech.com/backAdmin/study/inStudy</div>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">请求方式: </div>
          <div class="cont flex-1">POST</div>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">入参示例: </div>
          <pre class="cont flex-1">
            {
              "ask": "string",
              "channel": "string",
              "chapter": [
                {
                  "chapter": "string",
                  "joint": [
                    {
                      "file": "string",
                      "jointName": "string",
                      "jointNum": "string",
                      "jointTeacher": "string",
                      "jointTime": "string",
                      "videoLink": "string"
                    }
                  ]
                }
              ],
              "characteristic": "string",
              "conclusion": "string",
              "content": "string",
              "copyright": "string",
              "descs": "string",
              "dowland": "string",
              "hardwareAsk": "string",
              "interAsk": "string",
              "logo": "string",
              "name": "string",
              "pic": "string",
              "processMethod": "string",
              "recordNumber": "string",
              "result": "string",
              "serviceHotline": "string",
              "sort": "string",
              "state": "string",
              "studyIdList": "string",
              "studyLink": "string",
              "studyPrinciple": "string",
              "studyStep": "string",
              "sysName": "string",
              "sysPhone": "string",
              "systemAsk": "string",
              "teacher": "string",
              "teachingTarget": "string",
              "teamHead": "string",
              "teamUser": "string",
              "template": "string",
              "testLink": "string",
              "type": "string",
              "type2": "string",
              "video": "string",
              "videoBlurb": "string",
              "videoList": "string"
            }
          </pre>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">入参字段说明: </div>
          <pre class="cont flex-1">
            study_id: 实验id
            user_id: 用户id
            imageBase64: 图片base64
            ask: 考核要求
            channel: 渠道来源(课程 实验)
            chapter	[ 章节数组
              {
                chapter: 章节名称
                joint:	[
                  {
                    file: 课程文件

                    jointName: 节名称

                    jointNum: 节数

                    jointTeacher: 老师

                    jointTime: 时间

                    videoLink: 视频地址
                  }
                ]
              }
            ]
            characteristic: 项目特色
            conclusion: 实验结论与心得
            content: 内容描述
            copyright: copyright
            descs: 自定义介绍
            dowland: 是否可下载
            hardwareAsk: 硬件要求
            interAsk: 网络要求
            logo: logo
            name: 名称
            pic: 图片封面
            processMethod: 教学过程和实验方法
            recordNumber: 系统实验备案编号
            result: 实验结果与结论
            serviceHotline: 服务热线
            sort: 优先级
            state: 启用状态
            studyIdList: 实验ID（ID用,分割）
            studyLink: 我要上课链接
            studyPrinciple: 实验原理
            studyStep: 实验步骤
            sysName: 系统实验公司名称
            sysPhone: sysPhone
            systemAsk: 操作系统要求
            teacher: 讲师
            teachingTarget: 教学目标
            teamHead: 团队负责人
            teamUser: 团队成员
            template: 模板
            testLink: 我要实验链接
            type: 分类
            type2: 二级分类
            video: 视频封面
            videoBlurb: 视频简介
            videoList: 课程（视频地址用,分割）
          </pre>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">出参格式: </div>
          <div class="cont flex-1">JSON</div>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">出参示例: </div>
          <pre class="cont flex-1">
            {
              "code": 200,
              "msg": "请求成功",
              "data": null
            }
          </pre>
        </div>
        <div class="item flex jc-between ai-center">
          <div class="label">出参字段说明: </div>
          <div class="cont flex-1">code:200为成功 500异常</div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },

  created() {
  },
  activated() {
  },
  methods: {
  }
};
</script>
<style lang="scss">
.openApi {
  padding-top: 109px;
  .api {
    padding: 16px;
    background: #fff;
  }
  .item {
    padding: 16px;
    line-height: 48px;
    border-bottom: dashed 1px #ccc;
    &:last-child {
      border-bottom-color: transparent;
    }
    .label {
      font-size: 16px;
      color: #666;
      width: 200px;
    }
    .cont {
      margin-left: 12px;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
